module.exports = __webpack_public_path__ + "static/media/lock-red.9b2b5ba1.svg";